var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPmLogoWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "FULL_LOGO",
    "data-name": "FULL LOGO",
    xmlns: "http://www.w3.org/2000/svg",
    width: 167,
    height: 50,
    viewBox: "0 0 167 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #e41013;\n      }\n\n      .cls-1, .cls-2 {\n        fill-rule: evenodd;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "FULL_LOGO-2",
    "data-name": "FULL LOGO"
  }, /*#__PURE__*/React.createElement("path", {
    id: "POWER",
    className: "cls-1",
    d: "M52.614,27.616a4.69,4.69,0,0,0,4.832-4.967,3.138,3.138,0,0,0-3.468-3.379h-7.6L44.517,30.59h2.67l1.393-8.455h4.934a1.088,1.088,0,0,1,1.233,1.121,1.546,1.546,0,0,1-1.683,1.588H49.422l-0.45,2.771h3.642ZM64.862,30.59a6.567,6.567,0,0,0,6.371-6.7A4.294,4.294,0,0,0,66.72,19.27H64.064a6.274,6.274,0,0,0-6.313,6.462c0,2.787,1.756,4.858,4.455,4.858h2.656Zm-2.177-2.881a2.136,2.136,0,0,1-2.22-2.3,3.206,3.206,0,0,1,3.134-3.27h2.656A2.19,2.19,0,0,1,68.49,24.5a3.137,3.137,0,0,1-3.149,3.207H62.685Zm17.226,2.133a1.193,1.193,0,0,0,1.219.9,1.819,1.819,0,0,0,1.524-.9L89.692,19.27h-3L81.9,26.682,79.824,19.27H76.6l1.625,5.154L76.66,26.682,74.309,19.27H71.1l3.555,10.572a1.226,1.226,0,0,0,1.234.9,1.8,1.8,0,0,0,1.509-.9l1.712-2.631Zm18.865-3.924,0.348-2.164H93.755l-0.348,2.164h5.369ZM98.442,30.59l0.479-2.881h-7.1l0.914-5.574h7.067l0.465-2.865H90.533L88.676,30.59h9.766Zm14.135,0-2.6-3.394a4.509,4.509,0,0,0,2.8-4.453,3.177,3.177,0,0,0-3.439-3.472h-7.75L99.734,30.59h2.67l1.393-8.455h5.079a1.115,1.115,0,0,1,1.2,1.23,1.659,1.659,0,0,1-1.7,1.791H104.6l-0.406,2.413H106.8l1.974,3.021h3.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "MEET",
    className: "cls-2",
    d: "M129.516,30.678l-0.74-10.307a1.044,1.044,0,0,0-1.06-1.168,1.737,1.737,0,0,0-1.422.95l-4.15,6.384-1.9-6.384a1.193,1.193,0,0,0-1.161-.95,1.583,1.583,0,0,0-1.495,1.168l-4.15,10.307h2.626l2.554-6.337,1.64,5.434a1.22,1.22,0,0,0,1.2,1.059,1.88,1.88,0,0,0,1.494-1.059l3.628-5.434,0.291,6.337h2.641Zm11.029-4.671,0.348-2.164h-5.369l-0.349,2.164h5.37Zm-0.334,4.671,0.479-2.88h-7.1l0.914-5.574h7.067l0.464-2.865H132.3l-1.857,11.319h9.766ZM151.6,26.007l0.348-2.164h-5.369l-0.349,2.164h5.37Zm-0.334,4.671,0.479-2.88h-7.1l0.914-5.574h7.067l0.464-2.865H143.36L141.5,30.678h9.767Zm7.111,0,1.393-8.455h3.744l0.464-2.865H153.794l-0.464,2.865h3.758L155.7,30.678h2.685Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "MAIN_LOGO",
    "data-name": "MAIN LOGO"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Barbell"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.213,23.687H31.62v1.354H11.213V23.687Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_5_copy",
    "data-name": "Rectangle 5 copy",
    className: "cls-1",
    d: "M8.457,28.885a28.05,28.05,0,0,1,0-9.418H10.78a28.049,28.049,0,0,0,0,9.418H8.457Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_5_copy_4",
    "data-name": "Rectangle 5 copy 4",
    className: "cls-1",
    d: "M5.3,28.885a28.05,28.05,0,0,1,0-9.418H7.625a28.05,28.05,0,0,0,0,9.418H5.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_5_copy_5",
    "data-name": "Rectangle 5 copy 5",
    className: "cls-1",
    d: "M2.147,28.885a28.05,28.05,0,0,1,0-9.418H4.471a28.05,28.05,0,0,0,0,9.418H2.147Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_5_copy_2",
    "data-name": "Rectangle 5 copy 2",
    className: "cls-1",
    d: "M34.339,28.885a28.049,28.049,0,0,0,0-9.418H32.016a28.052,28.052,0,0,1,0,9.418h2.323Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_5_copy_6",
    "data-name": "Rectangle 5 copy 6",
    className: "cls-1",
    d: "M37.494,28.885a28.049,28.049,0,0,0,0-9.418H35.17a28.052,28.052,0,0,1,0,9.418h2.323Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_5_copy_6-2",
    "data-name": "Rectangle 5 copy 6",
    className: "cls-1",
    d: "M40.648,28.885a28.052,28.052,0,0,0,0-9.418H38.325a28.052,28.052,0,0,1,0,9.418h2.323Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.635,9.025h2.128v5.292H12.635V9.025Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_9_copy",
    "data-name": "Rectangle 9 copy",
    className: "cls-1",
    d: "M28.136,9.025h2.128v5.292H28.136V9.025Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.268,11.262L8.253,17.372H34.609l0.014-6.125H30.664v3.387h-2.9V11.248H15.154v3.429H12.269V11.248Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.253,31.428H10.53V35.14H32.29V31.428h2.333v6.04H8.253v-6.04Z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPmLogoWhite);
export default __webpack_public_path__ + "static/media/PM_logo_white.cfc9cd02f1e160c19a740a3aa455e0e2.svg";
export { ForwardRef as ReactComponent };